export const REPORT_ROUTE_NAMES = {
  OVERVIEW: 'reportsOverview',
  SALES: 'reportSales',
  SHOW_INSIGHTS: 'reportShowInsights',
} as const
